<div class="ppl-container-body">
    <div class="ppl-container-head">
        <ng-content select="[header]"></ng-content>
    </div>
    <div class="ppl-container">
        <div class="ppl-content-container">
            <ng-content select="[body]"></ng-content>
        </div>
    </div>
</div>